import { __decorate, __param } from 'tslib';
import { Directive, EventEmitter, ElementRef, Inject, ContentChild, ViewChild, Input, Output, HostBinding, HostListener, Component, ChangeDetectionStrategy, forwardRef, NgModule } from '@angular/core';
import { isNativeKeyboardFocusable, getClosestFocusable, isNativeFocusedIn, isElementEditable, setNativeFocused, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiObscuredModule, TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TuiDropdownDirective, TuiDropdownModule } from '@taiga-ui/core/directives/dropdown';
import { TuiDropdownControllerDirective, TUI_DROPDOWN_WATCHED_CONTROLLER, DROPDOWN_CONTROLLER_PROVIDER } from '@taiga-ui/core/directives/dropdown-controller';
import { isEditingKey } from '@taiga-ui/core/utils/miscellaneous';
import { CommonModule } from '@angular/common';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/directives/dropdown';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/core/directives/dropdown-controller';

const _c0 = ["wrapper"];
const _c1 = function (a0) { return { $implicit: a0 }; };
function TuiHostedDropdownComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4, 5);
    ɵngcc0.ɵɵlistener("keydown.esc", function TuiHostedDropdownComponent_ng_template_3_Template_div_keydown_esc_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onKeyDownEsc($event); })("keydown", function TuiHostedDropdownComponent_ng_template_3_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onKeydown($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "div");
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("content", ctx_r2.content)("context", ɵngcc0.ɵɵpureFunction1(2, _c1, _r0));
} }
const _c2 = ["*"];
let TuiHostedDropdownConnectorDirective = class TuiHostedDropdownConnectorDirective {
};
TuiHostedDropdownConnectorDirective.ɵfac = function TuiHostedDropdownConnectorDirective_Factory(t) { return new (t || TuiHostedDropdownConnectorDirective)(); };
TuiHostedDropdownConnectorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiHostedDropdownConnectorDirective, selectors: [["", "tuiHostedDropdownHost", ""]] });

var TuiHostedDropdownComponent_1;
let TuiHostedDropdownComponent = TuiHostedDropdownComponent_1 = class TuiHostedDropdownComponent {
    constructor(elementRef, controller) {
        this.elementRef = elementRef;
        this.controller = controller;
        this.content = '';
        this.canOpen = true;
        this.open = false;
        this.openChange = new EventEmitter();
        this.focusedChange = new EventEmitter();
    }
    get host() {
        return this.dropdownHost
            ? this.dropdownHost.nativeElement
            : this.elementRef.nativeElement;
    }
    get dropdown() {
        return !this.dropdownDirective || this.dropdownDirective.dropdownBoxRef === null
            ? null
            : this.dropdownDirective.dropdownBoxRef.location.nativeElement;
    }
    get nativeFocusableElement() {
        return isNativeKeyboardFocusable(this.host)
            ? this.host
            : getClosestFocusable(this.host, false, this.elementRef.nativeElement);
    }
    get focused() {
        return (isNativeFocusedIn(this.host) ||
            (this.open && !!this.wrapper && isNativeFocusedIn(this.wrapper.nativeElement)));
    }
    onFocusIn(target) {
        const host = this.dropdownHost
            ? this.dropdownHost.nativeElement
            : this.nativeFocusableElement || this.elementRef.nativeElement;
        if (!host.contains(target)) {
            this.updateOpen(false);
        }
    }
    onClick(target) {
        const host = this.nativeFocusableElement || this.host;
        const dropdownHost = this.dropdownHost ? this.dropdownHost.nativeElement : host;
        if (!this.hostEditable && dropdownHost.contains(target)) {
            this.updateOpen(!this.open);
        }
    }
    onKeyDownEsc(event) {
        if (!this.canOpen || !this.open) {
            return;
        }
        event.stopPropagation();
        this.closeDropdown();
    }
    onArrow(event, down) {
        this.focusDropdown(event, down);
    }
    onKeydown({ key, target, defaultPrevented }) {
        if (!defaultPrevented &&
            isEditingKey(key) &&
            this.hostEditable &&
            // TODO: iframe warning
            target instanceof HTMLElement &&
            !isElementEditable(target)) {
            this.focusHost();
        }
    }
    onActiveZone(active) {
        this.updateFocused(active);
        if (!active) {
            this.updateOpen(false);
        }
    }
    onHostObscured(obscured) {
        if (obscured) {
            this.closeDropdown();
        }
    }
    updateOpen(open) {
        if (open && !this.canOpen) {
            return;
        }
        this.open = open;
        this.openChange.emit(open);
    }
    get hostEditable() {
        const host = this.nativeFocusableElement || this.host;
        // TODO: iframe warning
        return host instanceof HTMLElement && isElementEditable(host);
    }
    focusDropdown(event, first) {
        const host = this.nativeFocusableElement;
        // TODO: iframe warning
        if (!host ||
            !(host instanceof HTMLElement) ||
            !(event.target instanceof Node) ||
            !host.contains(event.target)) {
            return;
        }
        if (!this.wrapper ||
            !this.open ||
            this.dropdown === null ||
            // TODO: iframe warning
            !(this.wrapper.nativeElement.nextElementSibling instanceof HTMLElement)) {
            this.updateOpen(true);
            if (!isElementEditable(host)) {
                event.preventDefault();
            }
            return;
        }
        const initial = first
            ? this.wrapper.nativeElement
            : this.wrapper.nativeElement.nextElementSibling;
        const focusable = getClosestFocusable(initial, !first, this.wrapper.nativeElement);
        if (focusable === null) {
            return;
        }
        setNativeFocused(focusable);
        event.preventDefault();
    }
    closeDropdown() {
        if (this.focused) {
            this.focusHost();
        }
        this.updateOpen(false);
    }
    focusHost() {
        const host = this.nativeFocusableElement;
        if (host !== null) {
            setNativeFocused(host, true, true);
        }
    }
    updateFocused(focused) {
        this.focusedChange.emit(focused);
    }
};
TuiHostedDropdownComponent.ɵfac = function TuiHostedDropdownComponent_Factory(t) { return new (t || TuiHostedDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_DROPDOWN_WATCHED_CONTROLLER)); };
TuiHostedDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiHostedDropdownComponent, selectors: [["tui-hosted-dropdown"]], contentQueries: function TuiHostedDropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiHostedDropdownConnectorDirective, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownHost = _t.first);
    } }, viewQuery: function TuiHostedDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(TuiDropdownDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownDirective = _t.first);
    } }, hostVars: 2, hostBindings: function TuiHostedDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function TuiHostedDropdownComponent_focusin_HostBindingHandler($event) { return ctx.onFocusIn($event.target); })("click", function TuiHostedDropdownComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); })("keydown.esc", function TuiHostedDropdownComponent_keydown_esc_HostBindingHandler($event) { return ctx.onKeyDownEsc($event); })("keydown.arrowDown", function TuiHostedDropdownComponent_keydown_arrowDown_HostBindingHandler($event) { return ctx.onArrow($event, true); })("keydown.arrowUp", function TuiHostedDropdownComponent_keydown_arrowUp_HostBindingHandler($event) { return ctx.onArrow($event, false); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_hosted_dropdown_focused", ctx.focused);
    } }, inputs: { content: "content", canOpen: "canOpen", open: "open" }, outputs: { openChange: "openChange", focusedChange: "focusedChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiHostedDropdownComponent_1)
            },
            DROPDOWN_CONTROLLER_PROVIDER,
        ])], ngContentSelectors: _c2, decls: 5, vars: 10, consts: [[1, "wrapper", 3, "tuiDropdownAlign", "tuiDropdownDirection", "tuiDropdownHost", "tuiDropdownLimitWidth", "tuiDropdownMinHeight", "tuiDropdownMaxHeight", "tuiDropdownSided", "tuiDropdownContent", "tuiDropdown", "tuiObscuredEnabled", "tuiObscured", "tuiActiveZoneChange"], ["activeZone", "tuiActiveZone"], ["polymorpheus", ""], ["dropdown", "polymorpheus"], ["polymorpheus-outlet", "", 3, "content", "context", "keydown.esc", "keydown"], ["wrapper", ""]], template: function TuiHostedDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("tuiObscured", function TuiHostedDropdownComponent_Template_div_tuiObscured_0_listener($event) { return ctx.onHostObscured($event); })("tuiActiveZoneChange", function TuiHostedDropdownComponent_Template_div_tuiActiveZoneChange_0_listener($event) { return ctx.onActiveZone($event); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, TuiHostedDropdownComponent_ng_template_3_Template, 3, 4, "ng-template", 2, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("tuiDropdownAlign", ctx.controller.align)("tuiDropdownDirection", ctx.controller.direction)("tuiDropdownHost", ctx.nativeFocusableElement)("tuiDropdownLimitWidth", ctx.controller.limitWidth)("tuiDropdownMinHeight", ctx.controller.minHeight)("tuiDropdownMaxHeight", ctx.controller.maxHeight)("tuiDropdownSided", ctx.controller.sided)("tuiDropdownContent", _r1)("tuiDropdown", ctx.open && ctx.canOpen)("tuiObscuredEnabled", ctx.open);
    } }, directives: [ɵngcc1.TuiDropdownDirective, ɵngcc2.TuiObscuredDirective, ɵngcc2.TuiActiveZoneDirective, ɵngcc3.PolymorpheusTemplate, ɵngcc3.PolymorpheusOutletComponent], styles: ["[_nghost-%COMP%]{display:inline-flex}.wrapper[_ngcontent-%COMP%]{border-radius:inherit;height:inherit;flex:1 1 auto;width:100%}.content[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-height:0}"], changeDetection: 0 });
TuiHostedDropdownComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiDropdownControllerDirective, decorators: [{ type: Inject, args: [TUI_DROPDOWN_WATCHED_CONTROLLER,] }] }
];
__decorate([
    ContentChild(TuiHostedDropdownConnectorDirective, { read: ElementRef })
], TuiHostedDropdownComponent.prototype, "dropdownHost", void 0);
__decorate([
    ViewChild('wrapper', { read: ElementRef })
], TuiHostedDropdownComponent.prototype, "wrapper", void 0);
__decorate([
    ViewChild(TuiDropdownDirective)
], TuiHostedDropdownComponent.prototype, "dropdownDirective", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiHostedDropdownComponent.prototype, "content", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiHostedDropdownComponent.prototype, "canOpen", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiHostedDropdownComponent.prototype, "open", void 0);
__decorate([
    Output()
], TuiHostedDropdownComponent.prototype, "openChange", void 0);
__decorate([
    Output()
], TuiHostedDropdownComponent.prototype, "focusedChange", void 0);
__decorate([
    HostBinding('class._hosted_dropdown_focused')
], TuiHostedDropdownComponent.prototype, "focused", null);
__decorate([
    HostListener('focusin', ['$event.target'])
], TuiHostedDropdownComponent.prototype, "onFocusIn", null);
__decorate([
    HostListener('click', ['$event.target'])
], TuiHostedDropdownComponent.prototype, "onClick", null);
__decorate([
    HostListener('keydown.esc', ['$event'])
], TuiHostedDropdownComponent.prototype, "onKeyDownEsc", null);
__decorate([
    HostListener('keydown.arrowDown', ['$event', 'true']),
    HostListener('keydown.arrowUp', ['$event', 'false'])
], TuiHostedDropdownComponent.prototype, "onArrow", null);
TuiHostedDropdownComponent = TuiHostedDropdownComponent_1 = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TUI_DROPDOWN_WATCHED_CONTROLLER))
], TuiHostedDropdownComponent);

let TuiHostedDropdownModule = class TuiHostedDropdownModule {
};
TuiHostedDropdownModule.ɵfac = function TuiHostedDropdownModule_Factory(t) { return new (t || TuiHostedDropdownModule)(); };
TuiHostedDropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiHostedDropdownModule });
TuiHostedDropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiObscuredModule,
            PolymorpheusModule,
            TuiActiveZoneModule,
            TuiDropdownModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHostedDropdownConnectorDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiHostedDropdownHost]'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHostedDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'tui-hosted-dropdown',
                template: "<div\n    #activeZone=\"tuiActiveZone\"\n    class=\"wrapper\"\n    [tuiDropdownAlign]=\"controller.align\"\n    [tuiDropdownDirection]=\"controller.direction\"\n    [tuiDropdownHost]=\"nativeFocusableElement\"\n    [tuiDropdownLimitWidth]=\"controller.limitWidth\"\n    [tuiDropdownMinHeight]=\"controller.minHeight\"\n    [tuiDropdownMaxHeight]=\"controller.maxHeight\"\n    [tuiDropdownSided]=\"controller.sided\"\n    [tuiDropdownContent]=\"dropdown\"\n    [tuiDropdown]=\"open && canOpen\"\n    [tuiObscuredEnabled]=\"open\"\n    (tuiObscured)=\"onHostObscured($event)\"\n    (tuiActiveZoneChange)=\"onActiveZone($event)\"\n>\n    <ng-content></ng-content>\n    <ng-template\n        #dropdown=\"polymorpheus\"\n        polymorpheus\n    >\n        <div\n            #wrapper\n            polymorpheus-outlet\n            [content]=\"content\"\n            [context]=\"{ $implicit: activeZone }\"\n            (keydown.esc)=\"onKeyDownEsc($event)\"\n            (keydown)=\"onKeydown($event)\"\n        ></div>\n        <!--This DIV is here to start backwards TreeWalker for focusing last focusable item on ArrowUp-->\n        <div></div>\n    </ng-template>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiHostedDropdownComponent_1)
                    },
                    DROPDOWN_CONTROLLER_PROVIDER,
                ],
                styles: [":host{display:inline-flex}.wrapper{border-radius:inherit;height:inherit;flex:1 1 auto;width:100%}.content{display:flex;flex-direction:column;min-height:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc4.TuiDropdownControllerDirective, decorators: [{
                type: Inject,
                args: [TUI_DROPDOWN_WATCHED_CONTROLLER]
            }] }]; }, { content: [{
            type: Input
        }], canOpen: [{
            type: Input
        }], open: [{
            type: Input
        }], openChange: [{
            type: Output
        }], focusedChange: [{
            type: Output
        }], focused: [{
            type: HostBinding,
            args: ['class._hosted_dropdown_focused']
        }], onFocusIn: [{
            type: HostListener,
            args: ['focusin', ['$event.target']]
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event.target']]
        }], onKeyDownEsc: [{
            type: HostListener,
            args: ['keydown.esc', ['$event']]
        }], onArrow: [{
            type: HostListener,
            args: ['keydown.arrowDown', ['$event', 'true']]
        }, {
            type: HostListener,
            args: ['keydown.arrowUp', ['$event', 'false']]
        }], dropdownHost: [{
            type: ContentChild,
            args: [TuiHostedDropdownConnectorDirective, { read: ElementRef }]
        }], wrapper: [{
            type: ViewChild,
            args: ['wrapper', { read: ElementRef }]
        }], dropdownDirective: [{
            type: ViewChild,
            args: [TuiDropdownDirective]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHostedDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiObscuredModule,
                    PolymorpheusModule,
                    TuiActiveZoneModule,
                    TuiDropdownModule,
                ],
                declarations: [TuiHostedDropdownComponent, TuiHostedDropdownConnectorDirective],
                exports: [TuiHostedDropdownComponent, TuiHostedDropdownConnectorDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiHostedDropdownModule, { declarations: function () { return [TuiHostedDropdownComponent, TuiHostedDropdownConnectorDirective]; }, imports: function () { return [CommonModule,
        TuiObscuredModule,
        PolymorpheusModule,
        TuiActiveZoneModule,
        TuiDropdownModule]; }, exports: function () { return [TuiHostedDropdownComponent, TuiHostedDropdownConnectorDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiHostedDropdownComponent, TuiHostedDropdownConnectorDirective, TuiHostedDropdownModule };

